<!-- Steps -->
<div class="flex flex-horiz-space-bw">
    <div class="m-b-15" *ngIf="!intakeNum" style="width: 70%;">
        <h3 class="heading">Intelligent Document Processing (IDP)</h3>
    </div>
    <div class="m-b-15 title-flex" *ngIf="intakeNum" style="width: 70%;">
        <h3 class="heading" style="margin-left: 10px !important;">{{intakeNum}}</h3>
        <nz-tag *ngIf="workflowStageCd" [nzColor]="'green'" style="margin-left: 10px !important;">
            {{workflowStageCd | technicalTranslate}}</nz-tag>
        <nz-tag *ngIf="currentModeKey" [nzColor]="'orange'">
                {{currentModeKey}}</nz-tag>
    </div>
    <div class="flex" style="flex-direction: row;
    justify-content: space-evenly;width:20%">
        <nz-cascader *ngIf="enableOCRModeCascader" [nzShowInput]="false" [nzOptions]="nzOptions" [nzExpandTrigger]="'hover'" [(ngModel)]="currentModeKey" (ngModelChange)="setOCRMode($event)" nzPlaceHolder="Please Select Mode" style="height: fit-content">
            <button nz-button nzType="primary" nzPlacement="bottomRight">
                 {{currentModeKey ? currentModeKey : "Select Mode" }} 
                <i nz-icon nzType="down"></i>
            </button>
        </nz-cascader>
        <button *ngIf="enableOCRModeSelect" nz-button nzType="primary" nz-dropdown [nzDropdownMenu]="OCRModeOptions" nzPlacement="bottomRight">
            <i *ngIf="currentMode && currentMode['icon']" nz-icon [nzType]="currentMode['icon']"></i> {{(currentMode && currentMode['name']) ? currentMode['name'] : "Select Mode" }} 
            <i nz-icon nzType="down"></i>
        </button>
        <nz-dropdown-menu #OCRModeOptions="nzDropdownMenu">
            <ul nz-menu nzSelectable>
                <ng-container *ngFor="let mode of OCRModes">
                    <li nz-menu-item *ngIf="mode.visible" (click)="setOCRMode(mode)" [nzDisabled]="!mode.enable"><i nz-icon [nzType]="mode.icon"></i> {{mode.name}}</li>
                </ng-container>
            </ul>
        </nz-dropdown-menu>
        <ng-container  *ngIf="enableNewOCROption">
            <button nz-popconfirm
            nzPopconfirmTitle="Do you want to create new IDP process?"
            nzOkText = "Continue with current process" nzCancelText = "Yes,create new process"
            [nzBeforeConfirm]="beforeConfirm"
            (nzOnConfirm)="createNewProcess()"
            (nzOnCancel)="uploadNewDocument()"
            nz-button
            nzType="primary" style="margin-left:20%">
                Upload New Document
            </button>
            <nz-divider nzType="vertical" style="margin-top: 3%;"></nz-divider>
            <i nz-icon nzType="more" nz-dropdown [nzDropdownMenu]="moreDetailsOptions" nz-tooltip nzTooltipTitle="More Options" style="margin-top: -10%;"></i>
           
            <nz-dropdown-menu #moreDetailsOptions="nzDropdownMenu">
                <ul nz-menu nzSelectable>
                    <ng-container *ngFor="let option of moreDetails">
                        <li nz-menu-item (click)="moreAction(option)" [nzDisabled]="!option.enable" [ngClass]="{'text-color-red' : option.key == 'CANCEL'}"><i nz-icon [nzType]="option.icon"></i> {{option.name}}</li>
                    </ng-container>
                </ul>
            </nz-dropdown-menu>
        </ng-container>
        <div *ngIf="!enableNewOCROption && !currentModeKey" class="m-l-15" style="width: 350px;height: 25px;margin-top: 3px;;">
            <!-- <span class="m-b-10"><span style="color: red;">* </span>Select Configuration</span> -->
            <nz-select nzShowSearch [(ngModel)]="selectedConfiguration" (ngModelChange)="setConfigurations()"
                style="width: 80%" nzSize="small">
                <nz-option *ngFor="let option of configurationLookup" [nzLabel]="option.lookupValue"
                    [nzValue]="option.lookupKey"></nz-option>
            </nz-select>
        </div>
    </div>
</div>  

<div class="flex" *ngIf="currentMode && !currentMode['key']">
    <div class="file-upload-sec ant-upload ant-upload-drag" style="padding:15px">
        <p class="ant-upload-drag-icon" style="margin-top:10px !important">
            <i nz-icon nzType="select" nzTheme="outline"></i>
        </p>
        <p class="ant-upload-text">Please select mode</p>
        <p class="ant-upload-hint">
            File uploads are limited to {{allowedFileSize}}MB in size and supported file formats are
            {{fileFormatSupported.toString()}}.<br>Use zip file only when multiple images and PDFs.
        </p>
    </div>
    <div class="tip-sec">
        <div class="tip-title-sec"><i nz-icon nzType="bulb" nzTheme="outline"></i> Pro Tip:</div>
        <div class="tip-msg">Before uploading, ensure your documents are clear and legible. High-quality scans and clear digital formats reduce processing errors and improve data extraction accuracy. This preparatory step saves time and enhances the overall efficiency of document processing.</div>
    </div>
</div>

 <div *ngIf="currentMode && currentMode['key']" [ngClass]="{'ocr-container' : (currentMode.key == 'IDPV2' || currentMode.key == 'IDPV3' || currentMode.key == 'IDPV4')}">
    <div class="flex" style="flex-direction: column;" *ngIf="currentMode && currentMode.key && (currentMode.key== 'IDPV2' || currentMode.key== 'IDPV3' || currentMode.key == 'IDPV4')">
        <nz-steps nzDirection="vertical" nzSize="small" [nzCurrent]="stepCurrent">
            <ng-container *ngFor="let step of steps;let index = index">
                <nz-step [class.current-step-highlight]="index == (stepCurrent-1)" [nzTitle]="step.title" [nzDescription]="step.desc||null" [nzStatus]="step.status"
                ></nz-step>
            </ng-container>
        </nz-steps>
        <div class="steps-action">
            <div>
            <button *ngIf="stepCurrent > 1" nz-button nzType="default" (click)="pre()">
                 <i nz-icon nzType="left"></i><span> Previous</span>
            </button>
            </div>
            <button *ngIf="stepCurrent < 4 && stepCurrentStatus != 'process' && stepCurrentStatus != 'wait' " nz-button nzType="default" (click)="next()" [nzLoading]="processing">
                <span>Next </span><i nz-icon nzType="right"></i>
            </button>
            
              <!-- <button nz-button nzType="primary" (click)="done()" [nzLoading]="processing">
                <span>Done</span>
              </button> -->
          </div>
    </div>

    <ng-container *ngIf="saveLoader">
        <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
            <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Saving {{steps[stepCurrent-1].title}}...</p>
          </div>
    </ng-container>
    <nz-spin *ngIf="currentMode && currentMode.key && !saveLoader" [nzSpinning]="processingOCR" [nzSize]="'large'" [nzIndicator]="ocrLoaderMsgTpl">
        <!-- document upload step -->
        <div *ngIf="'upload' == steps[stepCurrent-1].element">    
            <div class="" *ngIf="!isOCRFailed && !ocrGeneratedClaimNo && !showOCRExtractionResult && !showIDPV2RespCard && !finalStatus && !showAsyncFlowStatus && !enableRejectInfo; else showGenericMessage">
                <div class="file-upload-sec" [class.inputs-are-disabled]="!currentMode" style="height : 300px">
                    <nz-upload nzType="drag" *ngIf="currentMode && currentMode.key" [nzLimit]="1" [nzMultiple]="false" [nzBeforeUpload]="fileUploadBefore">
                        <p class="ant-upload-drag-icon">
                            <i nz-icon nzType="upload" nzTheme="outline"></i>
                        </p>
                        <p class="ant-upload-text">Click or drag file to this area to upload</p>
                        <p class="ant-upload-hint">
                            File uploads are limited to {{allowedFileSize}}MB in size and supported file formats are
                            {{fileFormatSupported.toString()}}.<br>
                            Use zip file only when multiple images and PDFs.
                        </p>
                    </nz-upload>
                </div>
                <div class="upload-tip-sec">
                    <div class="tip-title-sec"><i nz-icon nzType="bulb" nzTheme="outline"></i> Pro Tip:</div>
                    <div *ngIf="enableCarouselFeature" class="carousel-container">
                        <div class="carousel-item" [class.slide-in]="isVisible" [class.slide-out]="!isVisible">
                          {{ currentText }}
                        </div>
                        <button class="carousel-arrow left-arrow" (click)="prevSlide()">&#10094;</button>
                        <button class="carousel-arrow right-arrow" (click)="nextSlide()">&#10095;</button>
                    </div>
                      
                    <div *ngIf="!enableCarouselFeature" class="tip-msg">Before uploading, ensure your documents are clear and legible. High-quality scans and clear digital formats reduce processing errors and improve data extraction accuracy. This preparatory step saves time and enhances the overall efficiency of document processing.</div>
                </div>
            </div>
        </div>
        <!-- document classification step -->
        <div *ngIf="'classification' == steps[stepCurrent-1].element">
            <ng-container *ngIf="!isOCRFailed && showIDPV2RespCard && documentClassification && !showAsyncFlowStatus; else showGenericMessage">
                <div *ngFor="let data of documentClassification;let i = index">
                    <div class="view-data-section m-b-10">
                        <span (click)="isCollapsed[i] = !isCollapsed[i]">
                            <h2 class="heading-mms" style="background: #f6f6f6;
                        padding: 10px;">
                                <span *ngIf="data.mapped_requirement" class="p-r-10" nz-icon nzType="down-circle" [nzRotate]="isCollapsed ? 180 : 0"></span>
                                <ng-container *ngFor="let doc of documentClassifiedAsOptions">
                                    <span *ngIf="doc.lookupKey == data.mapped_requirement">{{doc.lookupValue}}</span>
                                </ng-container>
                                <!-- {{data.mapped_requirement}} -->
                            </h2>
                        </span>
                        <div *ngIf="!isCollapsed[i]" class="grid grid-1x grid-1x-responsive">                       
                            <div *ngIf="data.mapped_requirement">
                                <span class="s-c-heading">Document Name</span>
                                {{(data.file_name) || '-'}} 
                                <!-- <span style="font-size: 12px;">(size : 20mb)</span> -->
                                <button *ngIf="data.imageURL;else showDefaultBase64" class="m-l-10" nz-button nzType="dashed" nzSize="small" nz-tooltip nzTooltipTitle="View Document"
                                    nzPlacement="topCenter" (click)="viewDocument(data, 'preview')">
                                        <i nz-icon nzType="eye"></i>
                                </button>
                                <ng-template #showDefaultBase64>
                                    <button *ngIf="data && data.base64" class="m-l-10" nz-button nzType="dashed" nzSize="small" nz-tooltip nzTooltipTitle="View Document"
                                    nzPlacement="topCenter" (click)="viewDocumentBase64(data, 'preview')">
                                        <i nz-icon nzType="eye"></i>
                                    </button>
                                </ng-template>
                            </div>
                            <div *ngIf="data.documentType_explanation">
                                <span class="s-c-heading">Document Understanding</span>
                                {{(data.documentType_explanation) || '-'}}
                            </div>
                            <div *ngIf="data.mapped_requirement">
                                <span class="s-c-heading flex">Document Classified As  
                                    <span class="m-l-10" nz-tooltip nzTooltipTitle="Document Classification is type of document which is identified by IDP.">
                                        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                                    </span>
                                </span>
                                <nz-select nzShowSearch [(ngModel)]="data.mapped_requirement" style="width: 80%"  nzSize="small" (ngModelChange)="changeInDocumentClassification(data, i)" >
                                   <nz-option *ngFor="let option of documentClassifiedAsOptions" [nzLabel]="option.lookupValue" [nzValue]="option.lookupKey"></nz-option>
                                </nz-select>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="'interpretation' == steps[stepCurrent-1].element">
            <!-- <button class="m-l-10 m-r-20" style="float:right;" nz-button nzSize="small" nz-tooltip nzTooltipTitle="Edit Values"
            nzPlacement="topCenter" (click)="showJsonEditor = !showJsonEditor">
                <i nz-icon nzType="edit"></i> Update Details
            </button> -->
            <!-- <ng-container *ngIf="showJsonEditor && documentInterpretationResp && documentInterpretationResp.interpreted_information">
                <app-json-edit [inputJson]="documentInterpretationResp.interpreted_information" (jsonChange)="jsonUpdated($event)"></app-json-edit>
            </ng-container> -->
            <ng-container *ngIf="!isOCRFailed && interpretationSectionsJSON && !showAsyncFlowStatus; else showGenericMessage">
            <!-- Interpretation ribbon  -->
            <div *ngIf="documentClassification && documentClassification.length" class="card-summary-title card-summary-ribbon card-ribbon">
                <h3 class="prominent">
                    <div class="flex flex-horiz-space-bw flex-vert-center">
                      <div>
                        <span>Interpretation Overview</span>&nbsp;
                        <nz-tag *ngIf="request_id" [nzColor]="'#333'"><strong>Request ID : </strong>
                          {{request_id}}</nz-tag>
                      </div>
                    </div>
                </h3>
                <div class="grid grid-2x" style="grid-template-columns: auto 50%;">
                  <div >
                    <div class="grid grid-1x p-b-10">
                       <div class="flex">
                            <strong class="c-s-heading m-r-5">No. of Documents Received : </strong> 
                            <span *ngIf="documentClassification"> {{documentClassification.length ? documentClassification.length : 0}} files</span>
                        </div>
                    </div> 
                    <!-- Document Classification Details -->
                    <div *ngIf="documentClassification && documentClassification.length" >
                        <strong class="c-s-heading">Document Classification Details</strong>
                        <nz-list nzItemLayout="horizontal">
                            <nz-list-item *ngFor="let doc of documentClassification; let i = index;">
                                <nz-list-item-meta [nzTitle]="nzTitle" nzAvatar="" [nzDescription]="desc">
                                   <ng-template #nzTitle>
                                        <i nz-icon nzType="file-text"> </i> 
                                        <a *ngIf="doc.base64" (click)="viewDocumentBase64(doc, 'preview')" style="color:#1890ff;"> {{ doc.file_name }}</a>
                                        <span *ngIf="!doc.base64"> {{ doc.file_name }}</span>
                                    </ng-template>
                                    <ng-template #desc>
                                        <span *ngFor="let d of documentClassifiedAsOptions">
                                            <span *ngIf="d.lookupKey == doc.mapped_requirement" style="margin-left: 5%;">{{d.lookupValue}}</span>
                                        </span>
                                    </ng-template>
                                </nz-list-item-meta>
                            </nz-list-item>
                        </nz-list>
                    </div>
                  </div>
                  
                  <div style="border-left: 1px solid #e8e8e8;">
                    <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [labels]="chartOptions.labels"
                        [colors]="chartOptions.colors"
                        [fill]="chartOptions.fill"
                        [dataLabels]="chartOptions.dataLabels"
                        [responsive]="chartOptions.responsive"
                    ></apx-chart>
                  </div>
                </div>
            </div>
          
            <nz-alert nzType="info" class="m-t-20 m-r-20 m-l-20" nzMessage=" Below are the data points available to be corrected before finalizing. Click on the field to edit details." nzShowIcon></nz-alert>

               <app-view-summary [summarySectionsList]="interpretationSectionsJSON['summarySections']" [lookupList]="interpretationSectionsJSON['lookupCdList']" (fieldChange)="interpretationFieldChanged($event)"></app-view-summary>
                <div class="flex p-20" *ngIf="'interpretation' == steps[stepCurrent-1].element  && steps[stepCurrent-1].status != 'finish'">
                    <!-- <button class="m-r-10" nz-button nzType="primary" nzPlacement="bottomRight" (click)="acceptInterpretation()">Accept</button>
                    <button nz-button [nzType]="'danger'" nzPlacement="bottomRight" (click)="rejectInterpretation()">Reject</button> -->
                    <nz-radio-group [(ngModel)]="interpretationDecision" [nzButtonStyle]="'solid'" [nzSize]="'default'">
                        <label nz-radio-button nzValue="ACCEPT" (click)="interpretationDecisionChange('ACCEPT')" translate>
                        <i nz-icon nzType="" nzTheme="outline"></i> {{'Accept' | MMSTranslate}}</label>
                        <!-- <label nz-radio-button nzValue="RECTIFY" (click)="interpretationDecisionChange('RECTIFY')" translate>
                            <i nz-icon nzType="" nzTheme="outline"></i> {{'Rectify' | MMSTranslate}}</label> -->
                        <label nz-radio-button nzValue="REJECT" (click)="interpretationDecisionChange('REJECT')" translate>
                            <i nz-icon nzType="" nzTheme="outline"></i> {{'Reject' | MMSTranslate}}</label>
                    </nz-radio-group>
                </div>
                <div class="p-l-20" *ngIf="enableRejectReason">
                    <div class="m-t-10 grid grid-1x">
                        <span class="m-b-10"><span style="color: red;">* </span>Reason Category</span>
                        <nz-select nzShowSearch [(ngModel)]="rejectReasonCategory" (ngModelChange)="checkRejectReason()" style="width: 80%"  nzSize="small">
                            <nz-option *ngFor="let option of rejectionReasons" [nzLabel]="option.lookupValue" [nzValue]="option.lookupKey"></nz-option>
                        </nz-select>
                    </div>
                    <div class="m-t-10 grid grid-1x">
                        <span class="m-b-10"><span style="color: red;">* </span>Reason</span>
                        <textarea (ngModelChange)="checkRejectReason()" class="" rows="2" [maxlength]="'200'" nz-input
                        [(ngModel)]="rejectReason"></textarea>
                        <p style="font-size: xx-small;">
                            {{rejectReason ? rejectReason.length:
                            0}}/200 
                            Characters</p>
                    </div>
                </div>
            </ng-container>
            <!-- <button class="m-20" nz-button nzType="primary" nzPlacement="bottomRight" (click)="saveInterpretation()">Save</button> -->
        </div>
        <div *ngIf="'status' == steps[stepCurrent-1].element">
             <!-- <nz-result nzStatus="success" nzTitle="Intelligent Document Process Completed Successfully!" -->
                <nz-result *ngIf="finalStatus && finalStatus=='SUCCESS'" nzStatus="success" nzTitle="Proposal Created Successfully!"
                [nzSubTitle]="successResultSubTitle" style="padding-top: 0px !important;">
                <div nz-result-extra class="flex flex-content-center">
                    <div nz-result-extra>
                        <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                    </div>
                    <div nz-result-extra>
                        <button nz-button nzType="primary" (click)="openTransactionDetails()" class="m-r-15">Open Proposal</button>
                    </div>
                </div>
            </nz-result>
           
            <ng-template #defaultStatusMsg>
                <div *ngIf="showCancelIDPStep;else showErrorMsg">
                    <nz-result nzStatus="error" nzTitle="IDP process canceled."
                    [nzSubTitle]="failSubTitle" style="padding-top: 0px !important;">
                        <div nz-result-extra class="flex flex-content-center">
                            <div nz-result-extra>
                                <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                            </div>
                        </div>
                    </nz-result>
                </div>
            </ng-template>
            <ng-template #showErrorMsg>
                <div *ngIf="!enableRejectInfo">
                    <nz-result nzStatus="warning" nzTitle="IDP process completed with error."
                    [nzSubTitle]="failSubTitle" style="padding-top: 0px !important;">
                        <div nz-result-extra class="flex flex-content-center">
                            <div nz-result-extra>
                                <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                            </div>
                            <div nz-result-extra>
                                <button class="m-l-10 m-r-20" nz-button nz-tooltip nzTooltipTitle="Download Details"
                                nzPlacement="topCenter" (click)="downloadEncryptedJson()">
                                    <i nz-icon nzType="download"></i> Download Error Report
                                </button>
                            </div>
                        </div>
                    </nz-result>
                </div>
                <ng-container *ngIf="enableRejectInfo">
                    <nz-result nzStatus="error" nzTitle="IDP process is rejected!"
                        [nzSubTitle]="showRejectMsg">
                        
                        <div nz-result-extra class="">
                            <div class="flex" style="flex-direction: column;">
                                <ng-container *ngFor="let doc of rejectionReasons">
                                    <span *ngIf="doc.lookupKey == rejectReasonCategory">Reject Category : {{doc.lookupValue}}</span>
                                </ng-container>
                                <span *ngIf="rejectReason">Reject Reason : {{rejectReason}}</span>
                            </div>
                            <div nz-result-extra>
                                <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                            </div>
                        </div>
                    </nz-result>
                </ng-container>
            </ng-template>
        </div>
        <div  *ngIf="'upload' != steps[stepCurrent-1].element && 'status' != steps[stepCurrent-1].element && !showAsyncFlowStatus" class="footer __data-footer-primary">
            <div class="m-t-10 m-b-10" *ngIf="showRemarkTextArea && 'classification' == steps[stepCurrent-1].element">
                <span class="m-b-10">Remarks</span>
                <textarea class="" rows="1" [maxlength]="'200'" nz-input
                    [(ngModel)]="classificationRectificationRemark"></textarea>
                <p style="font-size: xx-small;">
                        {{classificationRectificationRemark ? classificationRectificationRemark.length:
                        0}}/200 
                        Characters</p>
            </div>
            <div class="m-t-10 m-b-10" *ngIf="showRemarkTextArea && 'interpretation' == steps[stepCurrent-1].element">
                <span class="m-b-10">Remarks</span>
                <textarea class="" rows="1" [maxlength]="'200'" nz-input
                    [(ngModel)]="interpretationRectificationRemark"></textarea>
                <p style="font-size: xx-small;">
                        {{interpretationRectificationRemark ? interpretationRectificationRemark.length:
                        0}}/200 
                        Characters</p>
            </div>
            <div>
                <div></div>
                <a *ngIf="('interpretation' == steps[stepCurrent-1].element || 'classification' == steps[stepCurrent-1].element)  && steps[stepCurrent-1].status != 'finish'" class="m-r-20" (click)="showRemarkTextArea=!showRemarkTextArea">Add Additional Remark</a>
                <button *ngIf="'interpretation' == steps[stepCurrent-1].element  && steps[stepCurrent-1].status != 'finish'"  class="m-20" style="float:right;" nz-button nzType="primary" nzPlacement="bottomRight" [disabled]="interpretationSaveDisabled" (click)="saveInterpretation()">Save & Proceed</button>
                <div style="float:right;" *ngIf="'classification' == steps[stepCurrent-1].element">
                    <button *ngIf="'classification' == steps[stepCurrent-1].element && steps[stepCurrent-1].status != 'finish' && currentMode.key != 'IDPV2'" class="m-r-20" nz-button nzType="primary" nzPlacement="bottomRight" (click)="saveClassiFication()">Save</button>
                    <button *ngIf="'classification' == steps[stepCurrent-1].element  && steps[stepCurrent-1].status != 'finish' && currentMode.key != 'IDPV2'" class="m-r-20" nz-button nzType="primary" nzPlacement="bottomRight" (click)="saveAndProceedClassiFication()">Proceed</button>
                    <button *ngIf="'classification' == steps[stepCurrent-1].element  && steps[stepCurrent-1].status != 'finish' && currentMode.key == 'IDPV2'" class="m-r-20" nz-button nzType="primary" nzPlacement="bottomRight" (click)="saveAndProceedClassiFication()">Save & Proceed</button>
                    <button *ngIf="'classification' == steps[stepCurrent-1].element  && steps[stepCurrent-1].status != 'finish'" nz-button nzType="danger" nzPlacement="bottomRight" (click)="modalCancelIDP=true">Cancel IDP</button>
                </div>
            </div>
        </div>
        <ng-template #showGenericMessage>
            <ng-container *ngIf="isOCRFailed && !showAsyncFlowStatus">
                <nz-result nzStatus="500" [nzTitle]="errorTitle" [nzSubTitle]="ocrFailedErrorMsg">
                    <div nz-result-extra>
                        <button nz-button nzType="primary" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                        <button nz-button nzType="default" (click)="retry();">Retry</button>
                        <button class="m-r-20" nz-button nz-tooltip nzTooltipTitle="Download Details"
                        nzPlacement="topCenter" (click)="downloadEncryptedJson()">
                            <i nz-icon nzType="download"></i> Download Error Report
                        </button>
                    </div>
                </nz-result>
            </ng-container>

            <ng-container *ngIf="!isOCRFailed && showIDPV2RespCard && !showAsyncFlowStatus">
                <nz-result *ngIf="!finalStatus && !showCancelIDPStep;else showError"> 
                    <div nz-result-extra>
                        <span nz-icon nzType="loading" nzTheme="outline"></span>
                        <h3>IDP is already in process.</h3>
                        <h5>Please continue with IDP process.</h5>
                    </div>
                </nz-result>
                <ng-template #showError>
                    <div *ngIf="showCancelIDPStep;else showSuccessStatus">
                        <nz-result  nzStatus="error" [nzTitle]="'IDP process canceled.'"> 
                        </nz-result>
                    </div>
                </ng-template>
                <ng-template #showSuccessStatus>
                    <div>
                        <nz-result  nzStatus="SUCCESS" [nzTitle]="'IDP process completed.'" *ngIf="finalStatus && finalStatus=='SUCCESS'"> 
                        </nz-result>
                    </div>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="this.currentMode['key']=='INITIATEIDP' && !isOCRFailed && finalStatus;">
                <nz-result *ngIf="finalStatus == 'SUCCESS'" [nzStatus]="'success'" nzTitle="IDP Process Completed Successfully!"
                    [nzSubTitle]="">
                    <div nz-result-extra class="flex flex-content-center">
                        <div nz-result-extra>
                            <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                        </div>
                    </div>
                </nz-result>
                <nz-result *ngIf="finalStatus != 'SUCCESS'" [nzStatus]="'error'" nzTitle="IDP Process Failed!"
                    [nzSubTitle]="">
                    <div nz-result-extra class="flex flex-content-center">
                        <div nz-result-extra>
                            <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                        </div>
                    </div>
                </nz-result>
                <ng-template #showError>
                    <div *ngIf="showCancelIDPStep;else showSuccessStatus">
                        <nz-result  nzStatus="error" [nzTitle]="'IDP process canceled.'"> 
                        </nz-result>
                    </div>
                </ng-template>
                <ng-template #showSuccessStatus>
                    <div>
                        <nz-result  nzStatus="SUCCESS" [nzTitle]="'IDP process completed.'" *ngIf="finalStatus && finalStatus=='SUCCESS'"> 
                        </nz-result>
                    </div>
                </ng-template>
            </ng-container>
            
            <ng-template #errorTitle>
                <div class="ant-result-title ng-star-inserted"> {{errorTitleMsg}}
                    <span nz-tooltip [nzTooltipTitle]="errorRespMsg">
                        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    </span>
                </div>
            </ng-template>

            <ng-container *ngIf="ocrGeneratedClaimNo">
                <nz-result nzStatus="success" nzTitle="Proposal Registered Successfully!"
                    [nzSubTitle]="successResultSubTitle">
                    <div nz-result-extra class="flex flex-content-center">
                        <div nz-result-extra>
                            <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                        </div>
                        <div nz-result-extra>
                            <button nz-button nzType="primary" (click)="openTransactionDetails()" class="m-r-15">Open Intimation</button>
                        </div>
                    </div>
                </nz-result>
            </ng-container>

            <ng-container *ngIf="extractionJSON">
                <div class="view-container">
                    <div class="m-b-15" style="display:flex">
                        <h4 class="heading">Extracted JSON</h4>
                        <p style="color:red;padding-left: 10px;">*</p>
                        <span style="font-size: 12px;padding-top: 3px;">
                            This is only for testing purpose.
                        </span>
                    </div>
                    <ngx-json-viewer [json]="extractionJSON"></ngx-json-viewer>
                </div>
            </ng-container>

            <ng-container *ngIf="showAsyncFlowStatus">
                <nz-result nzStatus="info" [nzTitle]="asyncMSGTitle"
                    [nzSubTitle]="'Please wait here till we process your documents or you can check this after some time.'">
                    <div nz-result-extra class="flex flex-content-center">
                        <div nz-result-extra>
                            <button nz-button nzType="default" (click)="backToSearchScreen()" class="m-r-15">Back to Search</button>
                        </div>
                        <div nz-result-extra *ngIf="!showRefreshButton">
                            <button nz-button nzType="primary" (click)="asyncWait()" class="m-r-15">Wait Here</button>
                        </div>
                        <div nz-result-extra *ngIf="showRefreshButton">
                            <button nz-button nzType="primary" (click)="fetchAsyncTransaction()" class="m-r-15">Refresh Page</button>
                        </div>
                    </div>
                </nz-result>
            </ng-container>

            <ng-template #successResultSubTitle>
                <div class="success-subTitles-Sec">Voilà! Your Intimation has been created, <span class="highlightClaimNum">{{ocrGeneratedClaimNo}}</span>.</div> <!--(click)="fetchTransaction(ocrGeneratedClaimNo)"-->
            </ng-template>

        </ng-template>
    </nz-spin>
</div>


<!-- temporory code for IDP V2 password capturing -->
<nz-modal [(nzVisible)]="showIDPV2PasswordModal" nzTitle="IDP V2/IDP V3 Password" nzWidth="50%"
(nzOnCancel)="showIDPV2PasswordModal=false" (nzOnOk)="showIDPV2PasswordModal=false;submitPassword()" nzOkText="Submit" nzCancelText="Cancel" nzWidth="500px" nzZIndex="100">
<ng-container *nzModalContent>
<div *ngIf="showIDPV2PasswordModal">
  <nz-form-item>
    <nz-form-label [nzSpan]="24">Enter Password</nz-form-label>
    <nz-form-control [nzSpan]="24">
      <input nz-input [type]="inputType" [(ngModel)]="capturedPassword"/>
      <nz-form-explain *ngIf="capturedPassword == null">
        <p style="color:red">
          Enter IDP Password
        </p>
      </nz-form-explain>
      <nz-form-explain>
        <p style="color:red;font-style: italic;font-size: 11px;">
          Note : IDP V2/IDP V3 is currently in Beta testing and available to select QA members.
        </p>
      </nz-form-explain>
      <nz-form-explain>
        <p style="color:red;font-style: italic;font-size: 11px;">
          Note : IDP V2 is currently in Beta testing and available to select QA members.
        </p>
      </nz-form-explain>
    </nz-form-control>
  </nz-form-item>
</div>
</ng-container>
</nz-modal>
<ng-template #ocrLoaderMsgTpl>
    <div class="loaderArea">
        <i nz-icon [nzType]="'loading'"></i>
        <div style="font-size:16px">
            <span class="f-w-600 col-dark">{{ocrLoaderMsg['title']}} </span>
            <span class="col-grey-dark"> - {{ocrLoaderMsg['description']}}</span>
        </div>
    </div>
</ng-template>

<div class="draggable-modals" *ngIf="documentPreview && enableDraggableBox">
    <app-ui-draggable-modal [documentPreviewData]="documentPreview" [dragBoxConfig]="draggableBoxesforDocument"></app-ui-draggable-modal>
</div>

<nz-modal [(nzVisible)]="modalFilePreview"
          [nzFooter]="null"
          [nzMaskClosable]="false"
          nzWidth="900px" nzZIndex="1080"
          [nzTitle]="documentName + ' (preview)'"
          (nzOnCancel)="modalFilePreview=false" (nzOnOk)="modalFilePreview=false"
>
<!-- [nzTitle]="guessFileName(previewFileUrl) + ' (preview)'" -->
<ng-container *nzModalContent>
  <div *ngIf="false" class="flex flex-both-center flex-dir-vert text-a-center">

    <!-- Show Loading if file is being downloaded -->
    <div *ngIf="fileIsBeingDownloaded" class="col-grey-light">
                <span style="display:block;padding:30px 0">
                  Fetching file... please wait
                </span>
      <nz-spin [nzSpinning]="true"></nz-spin>
    </div>

    <!-- No Data stream? Not previewable -->
    <div *ngIf="!fileIsBeingDownloaded && !previewDataStream">
      <h3 class="f-s-1-2r">{{guessFileType(previewFileUrl)}} 123</h3>
      <span>{{notSupportedText}}</span>
    </div>

    <!-- Special Case: Container el. for rendering decoded TIFF -->
    <div id="tiff-canvas" *ngIf="modalFilePreview"></div>

    <!-- Data Stream Exists? (&& modalFilePreview -> to stop video/audio on close of modal) -->
    <div *ngIf="!!previewDataStream && modalFilePreview">

      <ng-container [ngSwitch]="guessFileType(previewFileUrl)">

        <!-- Image Preview -->
        <div *ngSwitchCase="'Image'">
          <!-- TIFF -->
            <!-- -->
          <!-- Others -->
          <img [src]="previewDataStream" alt="" />
        </div>


        <!-- Video Preview -->
        <video controls autoplay loop *ngSwitchCase="'Video'" width="640" height="480" controlsList="nodownload">
          <source [src]="previewDataStream" type="video/mp4">
          Your browser does not support the <code>video</code> element.
        </video>

        <!-- Audio Preview -->
        <audio autoplay controls loop *ngSwitchCase="'Audio'" [src]="previewDataStream" controlsList="nodownload">
          Your browser does not support the <code>audio</code> element.
        </audio>

        <!-- PDF -->
        <div *ngSwitchCase="'PDF'">
          <!-- <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:640px">
          </pdf-viewer> -->
          <ngx-extended-pdf-viewer [src]="previewDataStream" useBrowserLocale="true" style="display: block; min-width:840px"></ngx-extended-pdf-viewer>
        </div>

        <!-- HTML -->
        <div *ngSwitchCase="'HTML'" class="w-100-pc">
          <div [innerHTML]="previewDataStream"></div>
        </div>

      </ng-container>
    </div>
  </div>
</ng-container>
</nz-modal>

<!-- Summary drawer -->
<nz-drawer [nzVisible]="showIDPSummaryModal" nzPlacement="right" [nzWidth]="'820px'" 
nzTitle="IDP Detailed Summary" (nzOnClose)="showIDPSummaryModal = false;">
<ng-container *nzDrawerContent>
    <div class="fade-in">
        <app-markdown [textContent]="idp_summary"></app-markdown>
    </div>
</ng-container>
</nz-drawer>

<!-- Audit Trail Drawer -->
<nz-drawer [nzVisible]="showAuditDrawer" nzPlacement="right" [nzWidth]="'400px'" 
nzTitle="Audit" (nzOnClose)="showAuditDrawer = false;">
<ng-container *nzDrawerContent>
    <div class="fade-in">
        <nz-tabset>
            <nz-tab nzTitle="Overall Audit" *ngIf="OverallAuditTrail && OverallAuditTrail.length">
                <nz-tab nzTitle="IDP Audit">
                    <nz-timeline  nzMode="left">
                        <nz-timeline-item [nzColor]="item.color" *ngFor="let item of (Array.isArray(OverallAuditTrail)? OverallAuditTrail : [])">
                        <ng-container>
                            <h4 class="f-w-600">{{(item.stageCd | technicalTranslate) || '-'}} <nz-tag class="m-l-5"
                                [nzColor]="item.color">{{(item.statusForTheStage  | technicalTranslate) || '-'}}</nz-tag>
                            </h4>
                            <p>
                            <span translate class="text-bold">Stage:</span> {{(item.stageCd | technicalTranslate) || '-'}} <br>
                            <span translate class="text-bold">Status:</span> {{(item.statusForTheStage | technicalTranslate) || '-'}} <br>
                            <!-- <span translate class="text-bold">{{'Date & Time' | MMSTranslate}}:</span>
                                {{(item?.createdDateTime | date:'dd-MMM-yy h:mm:ss a') || '-'}} <br> -->
                        </ng-container>
                        </nz-timeline-item>
                    </nz-timeline>
                </nz-tab>
            </nz-tab>
            <nz-tab nzTitle="Intake Audit" *ngIf="IntakeauditTrail && IntakeauditTrail.length">
                <nz-tab nzTitle="IDP Audit" *ngIf="IntakeauditTrail && IntakeauditTrail.length">
                    <nz-timeline  nzMode="left">
                        <nz-timeline-item [nzColor]="item.color" *ngFor="let item of (Array.isArray(IntakeauditTrail)? IntakeauditTrail : [])">
                        <ng-container>
                            <h4 class="f-w-600">{{(item.stageCd | technicalTranslate) || '-'}} <nz-tag class="m-l-5"
                                [nzColor]="item.color">{{(item.statusForTheStage  | technicalTranslate) || '-'}}</nz-tag>
                            </h4>
                            <p>
                            <span translate class="text-bold">Stage:</span> {{(item.stageCd | technicalTranslate) || '-'}} <br>
                            <span translate class="text-bold">Status:</span> {{(item.statusForTheStage | technicalTranslate) || '-'}} <br>
                            <span translate class="text-bold">{{'Date & Time' | MMSTranslate}}:</span>
                                {{(item?.createdDateTime | date:'dd-MMM-yy h:mm:ss a') || '-'}} <br>
                        </ng-container>
                        </nz-timeline-item>
                    </nz-timeline>
                </nz-tab>
            </nz-tab>
            <nz-tab nzTitle="IDP Audit" >
                <nz-timeline  nzMode="left">
                    <nz-timeline-item [nzColor]="item.color" *ngFor="let item of (Array.isArray(IDPauditTrail)? IDPauditTrail : [])">
                    <ng-container>
                        <h4 class="f-w-600">{{(item.stageCd | technicalTranslate) || '-'}} <nz-tag class="m-l-5"
                            [nzColor]="item.color">{{(item.statusForTheStage  | technicalTranslate) || '-'}}</nz-tag>
                        </h4>
                        <p>
                        <span translate class="text-bold">Stage:</span> {{(item.stageCd | technicalTranslate) || '-'}} <br>
                        <span translate class="text-bold">Status:</span> {{(item.statusForTheStage | technicalTranslate) || '-'}} <br>
                        <span translate class="text-bold">{{'Date & Time' | MMSTranslate}}:</span>
                            {{(item?.createdDateTime | date:'dd-MMM-yy h:mm:ss a') || '-'}} <br>
                    </ng-container>
                    </nz-timeline-item>
                </nz-timeline>
            </nz-tab>
        </nz-tabset>

        <nz-timeline *ngIf="false">
            <nz-timeline-item [nzColor]="item.color" *ngFor="let item of (Array.isArray(auditTrail)? auditTrail : [])">
            <ng-container>
                <h4 class="f-w-600">{{(item.stageCd | technicalTranslate) || '-'}} <nz-tag class="m-l-5"
                    [nzColor]="item.color">{{(item.statusForTheStage  | technicalTranslate) || '-'}}</nz-tag>
                </h4>
                <p>
                <span translate class="text-bold">Stage:</span> {{(item.stageCd | technicalTranslate) || '-'}} <br>
                <span translate class="text-bold">Status:</span> {{(item.statusForTheStage | technicalTranslate) || '-'}} <br>
                <span translate class="text-bold">{{'Date & Time' | MMSTranslate}}:</span>
                    {{(item?.createdDateTime | date:'dd-MMM-yy h:mm:ss a') || '-'}} <br>
            </ng-container>
            </nz-timeline-item>
        </nz-timeline>
    </div>
    <app-generic-zero-ui [list]="IDPauditTrail" icon="file-search" title=""
    message="Audit will be generated, once you save the transaction"></app-generic-zero-ui>
    </ng-container>
</nz-drawer>

<nz-modal [(nzVisible)]="modalCancelIDP" [nzFooter]="cancelIDPFooter" [nzMaskClosable]="false" nzWidth="500px"
    [nzTitle]="'Cancel IDP Reason'" (nzOnCancel)="modalCancelIDP=false" (nzOnOk)="cancelCurrentProcess()">
    <ng-container *nzModalContent>
        <div class="p-l-20">
            <div class="m-t-10 grid grid-1x">
                <span class="m-b-10"><span style="color: red;">* </span>Cancel Reason Category</span>
                <nz-select nzShowSearch [(ngModel)]="cancelReasonCategory" (ngModelChange)="checkCancelReason()"
                    style="width: 80%" nzSize="small">
                    <nz-option *ngFor="let option of rejectionReasons" [nzLabel]="option.lookupValue"
                        [nzValue]="option.lookupKey"></nz-option>
                </nz-select>
            </div>
            <div class="m-t-10 grid grid-1x">
                <span class="m-b-10"><span style="color: red;">* </span>Cancel Reason</span>
                <textarea (ngModelChange)="checkCancelReason()" class="" rows="2" [maxlength]="'200'" nz-input
                    [(ngModel)]="cancelReason"></textarea>
                <p style="font-size: xx-small;">
                    {{cancelReason ? cancelReason.length:
                    0}}/200
                    Characters</p>
            </div>
        </div>
    </ng-container>
    <ng-template #cancelIDPFooter>
        <div class="flex" style="justify-content: space-between;">
            <div></div>
            <div>
                <button (click)="modalCancelIDP=false" nz-button nzType="default">Cancel</button>
                <button [nzDisabled]="enableCancelIDPSaveButton" (click)="cancelCurrentProcess()" nz-button
                    nzType="primary">Save & Cancel</button>
            </div>
        </div>
    </ng-template>
</nz-modal>

 <!--Exception Details  -->
 <div>
    <div
      *ngIf="(_UIErrorList && _UIErrorList.length > 0)"
      class="error-panel" [ngClass]="{'error-panel-collapsed': errPanelCollapsed}">

      <div class="flexie-auto-grid clickable p-b-5" (click)="errorPanelToggle()">
        <div>
          <h4 class="col-red">Exceptions</h4>
        </div>
        <div class="text-a-right d-b">
          <i *ngIf="!errPanelCollapsed" class="anticon anticon-down"></i>
          <i *ngIf="errPanelCollapsed" class="anticon anticon-up"></i>
        </div>
      </div>


      <div>
        <!-- <ng-container
          *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0">

          <strong class="col-grey-dark">Validation Exceptions</strong>
          <ul class="error-list">
            <li *ngFor="let exception of payloadInEdit['exceptionDOList']">
              <span><label nz-checkbox [(ngModel)]="exception['overriddenFl']"
                  (ngModelChange)="checkOverridenException($event,exception)"></label>
              </span>
              <span>{{exception?.exceptionType}} : {{exception?.exceptionMessage}}</span>
            </li>
            <div
              *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length == 0">
              No
              Exceptions found</div>
          </ul>

        </ng-container> -->

        <ng-container *ngIf="_UIErrorList && _UIErrorList.length > 0">

          <strong class="col-grey-dark">Invalid Data</strong>
          <ul class="error-list">
            <li *ngFor="let error of _UIErrorList">
              <span>{{error?.fieldNameDescription}} : {{error?.errorMsg}}</span>
            </li>
            <div *ngIf="_UIErrorList && _UIErrorList.length == 0">No
              Exceptions found</div>
          </ul>

        </ng-container>

        <ng-container *ngIf="transactionFailedException && transactionFailedException.length > 0">
          <strong class="col-grey-dark">Server Error</strong>
          <ul class="error-list">
            <li *ngFor="let error of transactionFailedException">
              <span>{{error?.fieldNameDescription}} : {{error?.errorMsg}}</span>
            </li>
          </ul>
        </ng-container>

        <!-- View all -->
        <a *ngIf="((_UIErrorList && _UIErrorList.length > 0))"
          (click)="exceptionPanel(1)" class="d-b col-grey-dark p-t-b-5 b-1 text-a-center">View All
        </a>

      </div>

    </div>

  </div>
